import { render, staticRenderFns } from "./HostingKvmFirewall.vue?vue&type=template&id=8088d31e&scoped=true&"
import script from "./HostingKvmFirewall.vue?vue&type=script&lang=js&"
export * from "./HostingKvmFirewall.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmFirewall.vue?vue&type=style&index=0&id=8088d31e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8088d31e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8088d31e')) {
      api.createRecord('8088d31e', component.options)
    } else {
      api.reload('8088d31e', component.options)
    }
    module.hot.accept("./HostingKvmFirewall.vue?vue&type=template&id=8088d31e&scoped=true&", function () {
      api.rerender('8088d31e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmFirewall.vue"
export default component.exports